<template>
  <div>
    <v-btn 
      block
      @click="buttonClick"
      :loading="loading"
      :disabled="loading || disabled"
    >
      {{ title }}
      <v-icon
        v-if="upload"
        right
        dark
      >
        mdi-cloud-upload
      </v-icon>
      <v-icon
        v-if="filter"
        right
        dark
      >
        mdi-filter-menu-outline
      </v-icon>
      <v-icon
        v-if="bulk"
        right
        dark
      >
        mdi-table-check
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "ButtonField",
  data() {
    return {}
  },
  props: ['custom', 'title', 'loading', 'disabled', 'filter', 'upload', 'bulk'],
  methods: {
    buttonClick() {
      this.$emit('button-click');
    }
  }
};
</script>

<style>
</style>